import {
  Checkbox,
  Form,
  FormInstance,
  InputNumber,
  message,
  Space,
  Typography,
} from "antd";

interface IProps {
  form: FormInstance;
}

const CLevel = ({ form }: IProps) => {
  const hasPenalty = Form.useWatch("forCLevel", form);

  return (
    <div>
      <Form.Item
        label={
          <Typography.Title level={4} className="!m-0 cursor-pointer">
            C Level
          </Typography.Title>
        }
        layout="horizontal"
        name="forCLevel"
        valuePropName="checked"
        
      >
        <Checkbox />
      </Form.Item>

      {hasPenalty ? (
        <Space>
          <Form.Item
            name="cLevelAllowedHours"
            label="C Level Allowed Hours"
            rules={[
              { required: hasPenalty, message: "This field is required." },
              {
                validator: (_, value) =>
                  value > 24
                    ? Promise.reject("24 dan katta bo'lmasligi kerak")
                    : Promise.resolve(),
              },
            ]}
            required={hasPenalty}
          >
            <InputNumber
              min={0}
              onChange={(value: number | null) => {
                if (value ? value > 24 : null) {
                  message.warning("24 dan katta kiritib bo'lmaydi!");
                }
              }}
            />
          </Form.Item>
        </Space>
      ) : null}
    </div>
  );
};
export default CLevel;
